import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function News() {
  const [articles, setArticles] = useState([]);
  const [visibleCount, setVisibleCount] = useState(3);

  useEffect(() => {
    fetch("/data/articles_all.json")
      .then((res) => res.json())
      .then((data) => {
        const cleanData = data.map((article) => {
          let text = article.preview_text || "";
          const telegramIndex = text.indexOf("ЕЩЁ БОЛЬШЕ ИНТЕРЕСНОГО");
          if (telegramIndex !== -1) text = text.slice(0, telegramIndex);
          text = text.slice(0, 350);
          return {
            id: article.id,
            title: article.title,
            content_text: text,
            url: article.url,
            localImg: article.localImg,
            author: article.author,
            date: article.date,
          };
        });
        setArticles(cleanData.reverse());
      })
      .catch((err) => console.error("Ошибка загрузки новостей:", err));
  }, []);

  useEffect(() => {
    const updateVisibleCount = () => {
      const width = window.innerWidth;
      if (width < 768) setVisibleCount(3);
      else if (width < 1024) setVisibleCount(4);
      else setVisibleCount(3);
    };

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  const visibleArticles = articles.slice(0, visibleCount);

  return (
    <section className="news">
      <section className="news__up">
        <h2 className="news__title">Последние новости института</h2>
        <h3 className="news__subtitle">
          Мы постоянно развиваемся и улучшаем качество услуг
        </h3>
      </section>

      <div className="news__blocks">
        {visibleArticles.map((article) => (
          <section key={article.id} className="news__block">
            {article.localImg && (
              <img
                src={
                  Array.isArray(article.localImg)
                    ? article.localImg[0]
                    : article.localImg
                }
                alt={article.title}
                className="news__image"
              />
            )}
            <h4 className="news__photo_title">{article.title}</h4>
            <p className="news__photo_text">{article.content_text}...</p>
            <Link
              to={`/about/news#${article.id}`} // ✅ правильный синтаксис
              className="prevention__button news__button"
            >
              Подробнее
            </Link>
          </section>
        ))}
      </div>

      <h4 className="prevention__button news__button_all">
        <Link to="/about/news" className="prevention__link employees__link">
          Все новости
        </Link>
      </h4>
    </section>
  );
}
